import MovimientoList from './MovimientoList'
export {MovimientoList}
export default MovimientoList
